import { RouteRecordRaw } from 'vue-router'
import { privateRoute } from '@/router/navGuards'
import { navigation } from '@/compositions/services/lemmas/useNewLemmaGuards'

// The wizard's steps come from `useNewLemmaGuards` — labels, order and entry
// guards in one place. Only what the router adds lives here: each step's URL and
// the component behind it. The paths keep their original spelling; renaming them
// would break every link into the wizard.
const STEPS: Record<string, { path: string; component: RouteRecordRaw['component'] }> = {
  'lemmas/new/text': { path: '', component: () => import('@/components/lemmas/new/texts/Text') },
  'lemmas/new/lemma': { path: 'lemma', component: () => import('@/components/lemmas/new/lemma/Lemma') },
  'lemmas/new/attestations': {
    path: 'attestations',
    component: () => import('@/components/lemmas/new/attestation/Attestations'),
  },
  'lemmas/new/review': { path: 'review', component: () => import('@/components/lemmas/new/lemma/Review') },
}

export default [
  {
    name: 'lemmas/index',
    path: 'lemmas',
    component: () => import('@/components/lemmas/list/Lemmas'),
    meta: { private: true },
    beforeEnter: privateRoute,
  },
  {
    path: '/lemmas/:lemma_id',
    name: 'lemmas/show',
    component: () => import('@/components/lemmas/show/Lemma'),
    meta: { private: true },
    beforeEnter: privateRoute,
  },
  {
    path: '/notes',
    name: 'notes/mine',
    component: () => import('@/components/notes/MyNotes.vue'),
    meta: { private: true },
    beforeEnter: privateRoute,
  },
  {
    path: '/lemmas/new',
    name: 'lemmas/new',
    component: () => import('@/components/lemmas/new/New'),
    meta: { private: true },
    beforeEnter: privateRoute,
    children: navigation.map((step) => ({
      name: step.name,
      path: STEPS[step.name].path,
      meta: {
        text: step.text,
        index: step.index,
        canEnter: step.canEnter,
      },
      component: STEPS[step.name].component,
    })),
  },
] as RouteRecordRaw[]
